const AppBar = {
  defaultProps: {
    color: 'inherit',
  },
  styleOverrides: {
    root: {
      boxShadow: 'none',
    },
  },
};

export default AppBar;
